export async function loadXlsxModule() {
	return import('xlsx');
}

export async function loadDocxModule() {
	return import('docx');
}

export async function loadExcelJsModule() {
	const module = await import('exceljs');
	return module.default || module;
}
